var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Input as InputBase } from "@irati/ui/src/FormItem";
import ButtonBase from "@irati/ui/src/Button";
export var Input = styled(InputBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n  > div {\n    padding: 0;\n  }\n"], ["\n  margin-top: 10px;\n  > div {\n    padding: 0;\n  }\n"])));
export var Button = styled(ButtonBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 15px;\n  width: 100%;\n"], ["\n  margin-top: 15px;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2;
